import * as React from "react";
import {Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import DebtorAgedDebtsCell from "./DebtorAgedDebtsCell";

export default function TopDebtorsTable({debtors, onNavigateToCustomer}) {
    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Razón Social</TableCell>
                        <TableCell>Nombre de fantasía</TableCell>
                        <TableCell>Canal</TableCell>
                        <TableCell>Comprobantes</TableCell>
                        <TableCell>Saldo</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {debtors.map(debtor => (
                        <TableRow key={debtor.businessName}>
                            <TableCell>{debtor.position}</TableCell>
                            <TableCell>
                                <Button onClick={() => onNavigateToCustomer(debtor.businessName)}>
                                    {debtor.businessName}
                                </Button>
                            </TableCell>
                            <TableCell>{debtor.fantasyName}</TableCell>
                            <TableCell>{debtor.channel}</TableCell>
                            <TableCell>
                                <DebtorAgedDebtsCell agedDebts={debtor.agedDebts}
                                                     onAgedDebtClick={() => onNavigateToCustomer(debtor.businessName)}/>
                            </TableCell>
                            <TableCell>{debtor.amount}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
